import { Paperclip } from '@phosphor-icons/react';
import clsx from 'clsx';

import { extensionFromTitle } from '../utils';

type Props = {
  title: string;
  size?: number;
};

const EXTENSION_COLORS_MAP = new Map<string, string>([
  ['pdf', 'bg-red text-white'],
  ['ppt', 'bg-yellow-300 text-dark-900'],
  ['pptx', 'bg-yellow-300 text-dark-900'],
  ['doc', 'bg-blue text-white'],
  ['docx', 'bg-blue text-white'],
  ['xls', 'bg-green text-white'],
  ['xlsx', 'bg-green text-white'],
]);

export function FileExtensionBadge({ title }: Props) {
  const extension = extensionFromTitle(title);

  return (
    <span
      className={clsx('inline-flex shrink-0 items-center justify-center rounded text-center font-mono text-[10px] uppercase size-7', {
        [EXTENSION_COLORS_MAP.get(extension ?? '') ?? '']: extension,
      })}
    >
      {extension ?? <Paperclip size={14} weight="bold" aria-hidden />}
    </span>
  );
}
